import React, { useState } from 'react';
import {
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useDispatch } from 'react-redux';
import { IoIosArrowForward, IoIosArrowDown } from 'react-icons/io';
import { Link, NavLink as RRNavLink, useHistory } from 'react-router-dom';
import './Styles.css';
import { FiShoppingCart } from 'react-icons/fi';
import { FaInstagram } from 'react-icons/fa';
import { VscAccount } from 'react-icons/vsc';
import { HamburgerCollapse } from 'react-animated-burgers';
import ResponsiveModal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { logout } from '../redux/actions/auth';

const styles = {
  modal: {
    backgroundColor: 'white',
    boxShadow: 'none',
    display: 'flex',
    overflow: 'visible',
    width: '85%',
    padding: '0 0 3rem 0',
    margin: '0',
    height: 'auto',
    minWidth: '85%',
    justifyContent: 'start',
  },
  overlay: {
    backgroundColor: 'transparent',
    padding: '120px 0 0 0',
  },
  closeIcon: {
    display: 'block',
    height: '4rem',
    width: '4rem',
    fill: 'rgb(44,80,116)',
  },
  closeButton: {
    right: '-15%',
    top: '0px',
  },
};

const TheHeader = (props) => {
  const data = props;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = () => {
    dispatch(logout());
    history.push('/login');
  };
  return (
    <>
      {/* PC */}
      <nav className="navbar d-none d-lg-block">
        <div className="container" style={{ fontWeight: 'bold', lineHeight: '1.5' }}>
          <Link to="/" className="navbar-brand">
            <img src="/logo.png" height="50" alt="" />
          </Link>
          <div className="right d-flex flex-row align-items-center">
            <div className="mypage">
              <UncontrolledDropdown nav inNavbar className="d-block">
                <DropdownToggle
                  className="item-menu-mb"
                  nav
                  style={{
                    color: 'black',
                  }}
                >
                  <VscAccount style={{ fontSize: '1.5rem', marginRight: '10px' }} />
                  マイページ
                </DropdownToggle>
                <DropdownMenu
                  style={{
                    margin: '0', borderRadius: '25px', border: '0', backgroundColor: 'white',
                  }}
                >
                  {
                  data.isLoggedIn ? (
                    <>
                      <DropdownItem>
                        <NavLink
                          className="d-block"
                          to="/mypage"
                          style={{ color: 'rgb(44,81,115)' }}
                          exact
                          activeClassName="active"
                          tag={RRNavLink}
                        >
                          登録情報
                        </NavLink>
                      </DropdownItem>
                      <DropdownItem>
                        <NavLink
                          className="d-block"
                          style={{ color: 'rgb(44,81,115)' }}
                          to="/transaction"
                          exact
                          activeClassName="active"
                          tag={RRNavLink}
                        >
                          注文履歴
                        </NavLink>
                      </DropdownItem>
                      <DropdownItem>
                        <NavLink
                          className="d-block"
                          style={{ color: 'rgb(44,81,115)' }}
                          to="/update-card"
                          exact
                          activeClassName="active"
                          tag={RRNavLink}
                        >
                          クレジットカード情報更新
                        </NavLink>
                      </DropdownItem>
                      <DropdownItem>
                        <button
                          className="btn"
                          style={{ color: 'rgb(44,81,115)', padding: '0.5rem 1rem' }}
                          onClick={handleLogout}
                          type="button"
                        >
                          ログアウト
                        </button>

                      </DropdownItem>
                    </>
                  ) : (
                    <DropdownItem>
                      <NavLink
                        className="d-block"
                        to="/login"
                        style={{ color: 'rgb(44,81,115)' }}
                        exact
                        activeClassName="active"
                        tag={RRNavLink}
                      >
                        ログイン
                      </NavLink>
                    </DropdownItem>
                  )
                }
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <div className="d-flex">
              <Link
                style={{ color: 'black' }}
                to="/cart"
              >
                <FiShoppingCart style={{ fontSize: '1.5rem', marginRight: '10px' }} />
                カート
                <span
                  style={{
                    background: 'black',
                    color: 'white',
                    borderRadius: '20px',
                    padding: '5px 10px',
                    marginLeft: '10px',
                  }}
                >
                  {data.cartLength}
                </span>
              </Link>
            </div>
          </div>
        </div>
      </nav>
      <nav className="navbar d-none d-lg-block" style={{ backgroundColor: 'rgb(205,226,233)', fontWeight: 'bold' }}>
        <div className="container">
          <Nav style={{ padding: '10px' }} className="d-flex justify-content-between m-auto">
            <div style={{ borderRight: 'solid 2px white' }}>
              <NavItem className="mx-2 mx-xl-4">
                <NavLink style={{ color: 'rgb(44,81,115)' }} exact activeClassName="active" tag={RRNavLink} to="/product">全ての商品</NavLink>
              </NavItem>
            </div>
            <div style={{ borderRight: 'solid 2px white' }}>
              <NavItem className="mx-2 mx-xl-4">
                <NavLink style={{ color: 'rgb(44,81,115)' }} exact activeClassName="active" tag={RRNavLink} to="/subscription">定期便</NavLink>
              </NavItem>
            </div>
            <div style={{ borderRight: 'solid 2px white' }}>
              <NavItem className="mx-2 mx-xl-4">
                <NavLink style={{ color: 'rgb(44,81,115)' }} exact activeClassName="active" tag={RRNavLink} to="/single">単品</NavLink>
              </NavItem>
            </div>
            <div style={{ borderRight: 'solid 2px white' }}>
              <NavItem className="mx-2 mx-xl-4">
                <NavLink style={{ color: 'rgb(44,81,115)' }} exact activeClassName="active" tag={RRNavLink} to="/features">商品特長</NavLink>
              </NavItem>
            </div>
            <div style={{ borderRight: 'solid 2px white' }}>
              <NavItem className="mx-2 mx-xl-4">
                <NavLink style={{ color: 'rgb(44,81,115)' }} exact activeClassName="active" tag={RRNavLink} to="/company">会社概要</NavLink>
              </NavItem>
            </div>
            <div>
              <NavItem className="mx-2 mx-xl-4">
                <NavLink style={{ color: 'rgb(44,81,115)' }} exact activeClassName="active" tag={RRNavLink} to="/contact">お問い合わせ</NavLink>
              </NavItem>
            </div>
          </Nav>
        </div>
      </nav>
      {/* SP */}
      <nav className="navbar d-flex d-lg-none">
        <HamburgerCollapse
          isActive={isMenuOpen}
          toggleButton={toggleMenu}
          barColor="#333333"
        />
        <ResponsiveModal
          open={isMenuOpen}
          onClose={toggleMenu}
          styles={styles}
          animationDuration={500}
          focusTrapped
          closeIconSize={40}
          showCloseIcon
        >
          <div style={{ width: '100%' }}>
            <div
              className="row m-0 pl-4"
              style={{
                background: 'rgb(44,80,116)',
                color: 'white',
                width: '100%',
                lineHeight: '3',
                fontSize: '1.5rem',
                fontWeight: 'bold',
              }}
            >
              会員サービス
            </div>
            <NavLink
              className="row m-0 pl-4"
              style={{
                color: 'rgb(44,80,116)',
                fontSize: '1.5rem',
                width: '100%',
                background: 'white',
                borderBottom: 'solid 1px',
              }}
              exact
              activeClassName="active"
              tag={RRNavLink}
              to="/mypage"
            >
              マイページ
              <IoIosArrowDown style={{ float: 'right', marginTop: '5px' }} />
            </NavLink>
            {
                  data.isLoggedIn ? (
                    <>
                      <NavLink
                        className="row m-0 pl-4"
                        style={{
                          color: 'rgb(44,80,116)',
                          fontSize: '1.5rem',
                          width: '100%',
                          background: 'white',
                          paddingLeft: '15px',
                          borderBottom: 'solid 1px rgb(170,210,210)',
                        }}
                        exact
                        activeClassName="active"
                        tag={RRNavLink}
                        to="/mypage"
                      >
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;登録情報
                      </NavLink>
                      <NavLink
                        className="row m-0 pl-4"
                        style={{
                          color: 'rgb(44,80,116)',
                          fontSize: '1.5rem',
                          width: '100%',
                          background: 'white',
                          paddingLeft: '15px',
                          borderBottom: 'solid 1px rgb(170,210,210)',
                        }}
                        exact
                        activeClassName="active"
                        tag={RRNavLink}
                        to="/transaction"
                      >
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注文履歴
                      </NavLink>
                      <NavLink
                        className="row m-0 pl-4"
                        style={{
                          color: 'rgb(44,80,116)',
                          fontSize: '1.5rem',
                          width: '100%',
                          background: 'white',
                          paddingLeft: '15px',
                          borderBottom: 'solid 1px rgb(170,210,210)',
                        }}
                        exact
                        activeClassName="active"
                        tag={RRNavLink}
                        to="/update-card"
                      >
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;クレジットカード情報更新
                      </NavLink>
                      <button
                        className="row m-0 pl-4 btn d-inline-flex"
                        style={{
                          color: 'rgb(44,80,116)',
                          fontSize: '1.5rem',
                          width: '100%',
                          background: 'white',
                          paddingLeft: '15px',
                        }}
                        onClick={handleLogout}
                        type="button"
                      >
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ログアウト
                      </button>

                    </>
                  ) : (
                    <>
                      <NavLink
                        className="row m-0 pl-4"
                        style={{
                          color: 'rgb(44,80,116)',
                          fontSize: '1.5rem',
                          width: '100%',
                          background: 'white',
                          paddingLeft: '15px',
                        }}
                        exact
                        activeClassName="active"
                        tag={RRNavLink}
                        to="/login"
                      >
                        ログイン
                      </NavLink>
                    </>
                  )
            }
            <div
              className="row m-0 pl-4"
              style={{
                background: 'rgb(44,80,116)',
                color: 'white',
                width: '100%',
                lineHeight: '3',
                fontSize: '1.5rem',
                fontWeight: 'bold',
              }}
            >
              商品を探す
            </div>
            <NavLink
              className="row m-0 pl-4"
              style={{
                color: 'rgb(44,80,116)',
                fontSize: '1.5rem',
                width: '100%',
                background: 'white',
                borderBottom: 'solid 1px',
              }}
              exact
              activeClassName="active"
              tag={RRNavLink}
              to="/product"
            >
              全ての商品
              <IoIosArrowForward style={{ float: 'right', marginTop: '5px' }} />
            </NavLink>
            <NavLink
              className="row m-0 pl-4"
              style={{
                color: 'rgb(44,80,116)',
                fontSize: '1.5rem',
                width: '100%',
                background: 'white',
                borderBottom: 'solid 1px',
              }}
              exact
              activeClassName="active"
              tag={RRNavLink}
              to="/subscription"
            >
              定期便
              <IoIosArrowForward style={{ float: 'right', marginTop: '5px' }} />
            </NavLink>
            <NavLink
              className="row m-0 pl-4"
              style={{
                color: 'rgb(44,80,116)',
                fontSize: '1.5rem',
                width: '100%',
                background: 'white',
                borderBottom: 'solid 1px',
              }}
              exact
              activeClassName="active"
              tag={RRNavLink}
              to="/single"
            >
              単品
              <IoIosArrowForward style={{ float: 'right', marginTop: '5px' }} />
            </NavLink>
            <NavLink
              className="row m-0 pl-4"
              style={{
                color: 'rgb(44,80,116)',
                fontSize: '1.5rem',
                width: '100%',
                background: 'white',
                borderBottom: 'solid 1px',
              }}
              exact
              activeClassName="active"
              tag={RRNavLink}
              to="/features"
            >
              商品特長
              <IoIosArrowForward style={{ float: 'right', marginTop: '5px' }} />
            </NavLink>
            <div
              className="row m-0 pl-4"
              style={{
                background: 'rgb(44,80,116)',
                color: 'white',
                width: '100%',
                lineHeight: '3',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                alignItems: 'center',
              }}
            >
              <FaInstagram style={{ fontSize: '1.5rem', marginRight: '1rem', lineHeight: '2.5' }} />
              <a href="https://instagram.com/terracoathikari?utm_medium=copy_link" target="blank" style={{ color: 'white' }}>INSTAGRAM</a>
            </div>
          </div>
        </ResponsiveModal>
        <Link to="/" className="navbar-brand m-auto">
          <img src="/logo.png" height="35" alt="" />
        </Link>
        <div className="d-flex">
          <Link
            style={{ color: 'black' }}
            to="/cart"
          >
            <FiShoppingCart style={{ fontSize: '2.2rem', marginRight: '10px' }} />
            <span
              style={{
                background: 'black',
                color: 'white',
                borderRadius: '20px',
                padding: '5px 10px',
                marginLeft: '10px',
              }}
            >
              {data.cartLength}
            </span>
          </Link>
        </div>
      </nav>
    </>
  );
};
export default TheHeader;
